<template>
    <TinymceEditor
        ref="baoKaoEditorInfo"
        v-model="changeValue"
        :bizPath="$bizPath.baoKaoEditorInfo"
        :formType="formType" />
</template>

<script>
import TinymceEditor from '@/components/TinymceEditor';
import { DataEntryMixin } from './mixins';
export default {
    name: 'SdRichText',
    props: {
        formType: {
            type: String,
            default: '',
        },
    },
    mixins: [DataEntryMixin],
    components: { TinymceEditor }
};
</script>

<style scoped>

</style>
